document.documentElement.classList.remove('no-js');

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

window.addEventListener('load', () => {
  const loader = document.querySelector('[data-preloader]');
  document.body.classList.add('is-loaded');
  if (loader) window.setTimeout(() => loader.classList.add('is-gone'), 680);
});

const cursor = document.querySelector('[data-cursor]');
if (cursor && !reducedMotion && window.matchMedia('(pointer:fine)').matches) {
  window.addEventListener('pointermove', (event) => {
    cursor.style.transform = `translate(${event.clientX}px, ${event.clientY}px) translate(-50%, -50%) rotate(45deg)`;
    document.documentElement.style.setProperty('--pointer-x', `${event.clientX}px`);
    document.documentElement.style.setProperty('--pointer-y', `${event.clientY}px`);
  }, { passive: true });
  document.addEventListener('pointerover', (event) => {
    cursor.classList.toggle('is-active', Boolean(event.target.closest('a,button,input,select')));
  });
}

const glitchTargets = [...document.querySelectorAll('[data-glitch]')];
if (glitchTargets.length) {
  const fireGlitch = () => {
    const target = glitchTargets[Math.floor(Math.random() * glitchTargets.length)];
    target.classList.add('glitch-now');
    window.setTimeout(() => target.classList.remove('glitch-now'), 180);
    window.setTimeout(fireGlitch, 2800 + Math.random() * 4200);
  };
  window.setTimeout(fireGlitch, 1800);
}

document.querySelectorAll('[data-password-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const panel = document.querySelector('[data-password-panel]');
    if (!panel) return;
    panel.hidden = !panel.hidden;
    if (!panel.hidden) panel.querySelector('input')?.focus();
  });
});

document.querySelectorAll('[data-countdown]').forEach((clock) => {
  const target = new Date(clock.dataset.countdown).getTime();
  if (!Number.isFinite(target)) return;
  const render = () => {
    const remaining = Math.max(0, target - Date.now());
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor((remaining % 86400000) / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    const set = (name, value) => { const node = clock.querySelector(`[data-${name}]`); if (node) node.textContent = String(value).padStart(2, '0'); };
    set('days', days); set('hours', hours); set('minutes', minutes); set('seconds', seconds);
  };
  render();
  window.setInterval(render, 1000);
});

document.querySelectorAll('[data-sqrd-vfx]').forEach((vfxCanvas) => {
  const context = vfxCanvas.getContext('2d');
  let width = 0;
  let height = 0;
  let ratio = 1;
  let stars = [];
  let nextTear = 0;
  let activeTears = [];

  const reset = () => {
    const bounds = vfxCanvas.getBoundingClientRect();
    ratio = Math.min(window.devicePixelRatio || 1, 1.5);
    width = Math.max(1, Math.round(bounds.width));
    height = Math.max(1, Math.round(bounds.height));
    vfxCanvas.width = Math.round(width * ratio);
    vfxCanvas.height = Math.round(height * ratio);
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
    const count = width < 600 ? 58 : 115;
    stars = Array.from({ length: count }, () => ({
      x: Math.random() * width,
      y: Math.random() * height,
      size: Math.random() * 1.45 + 0.25,
      speed: Math.random() * 0.24 + 0.05,
      phase: Math.random() * Math.PI * 2
    }));
  };

  const renderVfx = (time) => {
    context.fillStyle = '#030303';
    context.fillRect(0, 0, width, height);

    stars.forEach((star) => {
      star.y += star.speed;
      star.x += star.speed * 0.12;
      if (star.y > height + 3) { star.y = -3; star.x = Math.random() * width; }
      const pulse = 0.3 + Math.abs(Math.sin(time * 0.0018 + star.phase)) * 0.7;
      context.fillStyle = `rgba(255,255,255,${pulse})`;
      context.fillRect(star.x, star.y, star.size, star.size);
    });

    if (time > nextTear) {
      const tears = 2 + Math.floor(Math.random() * 4);
      for (let index = 0; index < tears; index += 1) {
        activeTears.push({
          y: Math.random() * height,
          h: Math.random() * 5 + 1,
          x: Math.random() * width * 0.35,
          lineWidth: width * (0.18 + Math.random() * 0.58),
          color: index % 2 ? 'rgba(255,45,178,.38)' : 'rgba(20,231,255,.4)',
          until: time + 100 + Math.random() * 190
        });
      }
      nextTear = time + 420 + Math.random() * 950;
    }

    activeTears = activeTears.filter((tear) => time < tear.until);
    activeTears.forEach((tear) => {
      const jitter = Math.random() * 18 - 9;
      context.fillStyle = tear.color;
      context.fillRect(tear.x + jitter, tear.y, tear.lineWidth, tear.h);
      context.fillStyle = 'rgba(255,255,255,.5)';
      context.fillRect(Math.max(0, tear.x - 24 - jitter), tear.y + tear.h + 1, tear.lineWidth * 0.48, 1);
    });

    const sweep = (time * 0.085) % (height + 120) - 60;
    const beam = context.createLinearGradient(0, sweep - 24, 0, sweep + 24);
    beam.addColorStop(0, 'rgba(20,231,255,0)');
    beam.addColorStop(0.5, 'rgba(20,231,255,.065)');
    beam.addColorStop(1, 'rgba(255,45,178,0)');
    context.fillStyle = beam;
    context.fillRect(0, sweep - 24, width, 48);
    window.requestAnimationFrame(renderVfx);
  };

  reset();
  window.addEventListener('resize', reset, { passive: true });
  window.requestAnimationFrame(renderVfx);
});

document.querySelectorAll('[data-parallax-hero]').forEach((hero) => {
  if (!window.matchMedia('(pointer:fine)').matches) return;
  const content = hero.querySelector('.sqrd-hero__content');
  const status = hero.querySelector('.sqrd-hero__status');
  hero.addEventListener('pointermove', (event) => {
    const bounds = hero.getBoundingClientRect();
    const x = (event.clientX - bounds.left) / bounds.width - 0.5;
    const y = (event.clientY - bounds.top) / bounds.height - 0.5;
    if (content) content.style.transform = `translate3d(${x * -10}px,${y * -8}px,0)`;
    if (status) status.style.transform = `translate3d(${x * 16}px,${y * 14}px,0)`;
  }, { passive: true });
  hero.addEventListener('pointerleave', () => {
    if (content) content.style.transform = '';
    if (status) status.style.transform = '';
  });
});

// Irregular horizontal signal cuts: brief enough to feel intentional, never noisy.
const signalSlice = document.querySelector('[data-signal-slice]');
if (signalSlice && !reducedMotion) {
  const pulseSignal = () => {
    document.documentElement.style.setProperty('--signal-y', `${8 + Math.random() * 78}%`);
    document.documentElement.style.setProperty('--signal-shift', `${Math.round(Math.random() * 48 - 24)}px`);
    signalSlice.classList.add('is-live');
    window.setTimeout(() => signalSlice.classList.remove('is-live'), 150 + Math.random() * 130);
    window.setTimeout(pulseSignal, 2400 + Math.random() * 4800);
  };
  window.setTimeout(pulseSignal, 1400);
}

const revealTargets = [...document.querySelectorAll('[data-reveal]')];
revealTargets.forEach((target, index) => target.style.setProperty('--reveal-delay', `${(index % 4) * 70}ms`));
if ('IntersectionObserver' in window && !reducedMotion) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.14 });
  revealTargets.forEach((target) => revealObserver.observe(target));
} else {
  revealTargets.forEach((target) => target.classList.add('is-revealed'));
}

if (!reducedMotion && window.matchMedia('(pointer:fine)').matches) {
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    card.addEventListener('pointermove', (event) => {
      const bounds = card.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      card.style.setProperty('--card-rx', `${y * -6}deg`);
      card.style.setProperty('--card-ry', `${x * 8}deg`);
      card.style.setProperty('--card-light-x', `${(x + 0.5) * 100}%`);
      card.style.setProperty('--card-light-y', `${(y + 0.5) * 100}%`);
    }, { passive: true });
    card.addEventListener('pointerleave', () => {
      card.style.setProperty('--card-rx', '0deg');
      card.style.setProperty('--card-ry', '0deg');
    });
  });
}

document.querySelectorAll('.sqrd-hero__title-wrap').forEach((title) => {
  if (reducedMotion) return;
  const retune = () => {
    title.style.setProperty('--tear-a', `${20 + Math.random() * 24}%`);
    title.style.setProperty('--tear-b', `${58 + Math.random() * 22}%`);
    title.classList.add('is-retuning');
    window.setTimeout(() => title.classList.remove('is-retuning'), 180);
    window.setTimeout(retune, 1500 + Math.random() * 3000);
  };
  window.setTimeout(retune, 900);
});



// Launch commerce controls: accessible quantity stepper and live variant pricing.
document.querySelectorAll('[data-quantity-control]').forEach((control) => {
  const input = control.querySelector('.sqrd-quantity__input');
  const minus = control.querySelector('[data-quantity-minus]');
  const plus = control.querySelector('[data-quantity-plus]');
  if (!input) return;

  const clampQuantity = (value) => {
    const minimum = Number.parseInt(input.min || '1', 10);
    return Math.max(minimum, Number.parseInt(value || minimum, 10) || minimum);
  };

  minus?.addEventListener('click', () => {
    input.value = String(clampQuantity(Number(input.value) - 1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  plus?.addEventListener('click', () => {
    input.value = String(clampQuantity(Number(input.value) + 1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  input.addEventListener('change', () => {
    input.value = String(clampQuantity(input.value));
  });
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const select = form.querySelector('[data-variant-select]');
  const pricing = form.closest('.sqrd-product__info')?.querySelector('[data-product-pricing]');
  if (!select || !pricing) return;

  const currentPrice = pricing.querySelector('[data-current-price]');
  const comparePrice = pricing.querySelector('[data-compare-price]');
  const badge = pricing.querySelector('.sqrd-sale-badge');

  const refreshVariantPrice = () => {
    const option = select.options[select.selectedIndex];
    const onSale = option?.dataset.onSale === 'true';
    if (currentPrice && option?.dataset.price) currentPrice.textContent = option.dataset.price;
    if (comparePrice) {
      comparePrice.textContent = option?.dataset.comparePrice || '';
      comparePrice.hidden = !onSale;
    }
    if (badge) badge.hidden = !onSale;
  };

  select.addEventListener('change', refreshVariantPrice);
  refreshVariantPrice();
});



// Per-size stock enforcement and live size pricing.
document.querySelectorAll('[data-product-form]').forEach((form) => {
  const variantInputs = [...form.querySelectorAll('[data-variant-input]')];
  const quantity = form.querySelector('.sqrd-quantity__input');
  const quantityControl = form.querySelector('[data-quantity-control]');
  const minus = quantityControl?.querySelector('[data-quantity-minus]');
  const plus = quantityControl?.querySelector('[data-quantity-plus]');
  const pricing = form.closest('.sqrd-product__info')?.querySelector('[data-product-pricing]');
  const currentPrice = pricing?.querySelector('[data-current-price]');
  const comparePrice = pricing?.querySelector('[data-compare-price]');
  const saleBadge = pricing?.querySelector('.sqrd-sale-badge');

  const syncQuantityToStock = () => {
    if (!quantity) return;
    const minimum = Number.parseInt(quantity.min || '1', 10);
    const rawMaximum = quantity.getAttribute('max');
    const maximum = rawMaximum === null ? Number.POSITIVE_INFINITY : Number.parseInt(rawMaximum, 10);
    let nextValue = Number.parseInt(quantity.value || minimum, 10) || minimum;

    if (Number.isFinite(maximum) && maximum <= 0) {
      quantity.value = '0';
      quantity.disabled = true;
      if (minus) minus.disabled = true;
      if (plus) plus.disabled = true;
      return;
    }

    quantity.disabled = false;
    nextValue = Math.max(minimum, nextValue);
    if (Number.isFinite(maximum)) nextValue = Math.min(maximum, nextValue);
    quantity.value = String(nextValue);
    if (minus) minus.disabled = nextValue <= minimum;
    if (plus) plus.disabled = Number.isFinite(maximum) && nextValue >= maximum;
  };

  const refreshVariant = () => {
    const variant = variantInputs.find((input) => input.checked);
    if (!variant) {
      syncQuantityToStock();
      return;
    }

    const stockLimit = variant.dataset.stockLimit;
    if (quantity) {
      if (stockLimit === undefined || stockLimit === '') quantity.removeAttribute('max');
      else quantity.setAttribute('max', stockLimit);
    }

    const onSale = variant.dataset.onSale === 'true';
    if (currentPrice && variant.dataset.price) currentPrice.textContent = variant.dataset.price;
    if (comparePrice) {
      comparePrice.textContent = variant.dataset.comparePrice || '';
      comparePrice.hidden = !onSale;
    }
    if (saleBadge) saleBadge.hidden = !onSale;
    syncQuantityToStock();
  };

  quantity?.addEventListener('input', syncQuantityToStock);
  quantity?.addEventListener('change', syncQuantityToStock);
  variantInputs.forEach((input) => input.addEventListener('change', refreshVariant));
  refreshVariant();
});
